import type { Category, EventInstance, Member } from '@pacer/shared';

const MUTED = 'var(--color-text-muted)';

/**
 * The colour an event renders in, by precedence:
 *   explicit event colour → its category → its first person → muted.
 * One rule, shared by the calendar grid, the day panel and the dashboard, so the same
 * event is never two colours in two places.
 */
export function eventColor(
  ev: EventInstance,
  members: Member[],
  categories: Category[],
): string {
  if (ev.color) return ev.color;
  const cat = ev.categoryId ? categories.find((c) => c.id === ev.categoryId) : undefined;
  if (cat) return cat.color;
  const owner = members.find((m) => m.id === ev.memberIds[0]);
  return owner?.color ?? MUTED;
}

export function eventCategory(ev: EventInstance, categories: Category[]): Category | undefined {
  return ev.categoryId ? categories.find((c) => c.id === ev.categoryId) : undefined;
}
